import React from 'react'
import { Link } from "react-router-dom";


const DrRohitDubey = () => {
    return (
        <>
            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2> Dr. Rohit Dubey </h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}> M.B.B.S, MS, Surgery (MGM Indore) General And Laproscopic Surgeon</li>
                    </ul>
                </div>
            </section>

            <section className="process-one" style={{ marginTop: "-90px" }}>
                <div className="auto-container">
                    <div className="row clearfix">
                        <marquee width="100%" direction="left" height="" ><br />
                                       <b className='' style={{ fontSize: "18px", color: "green" }}> 
                                        आँतो में सूजन एवं रुकावट, दूरबीन द्वारा पित्त की थैली का ऑपरेशन अपेंडिक्स का ऑपरेशन, फिस्टुला का ऑपरेशन, गाँठ व मवाद का इलाज व पेट संबंधी अन्य किसी भी रोग से ग्रस्त हैं।
                                          </b>
                                   </marquee>
                     {/* Process Block */}
                        <div className="process-block col-lg-4 col-md-12 col-sm-12">
                            <div className="process-block_inner">
                                <div className="process-block_image">
                                    <span className="process-block_icon flaticon-medical-history" style={{ color: '#0f903f' }} />
                                    <img src="assets/img/Dr. Rohit Dubey.webp" alt />
                                </div>
                            </div>
                        </div>
                        {/* Process Block */}
                        <div className="process-block col-lg-8 col-md-12 col-sm-12">
                            <div className="process-block_inner">
                                <div className="process-block_content">
                                    {/* <div className="process-block_title">
                                                   <span className="process-block_number"> 8 Years experience</span>
                                               </div> */}
                                    <br />
                                    <br />
                                    <br />
                                    <h3 className="process-block_heading">Dr. Rohit Dubey </h3>
                                    <p> M.B.B.S, MS, Surgery (MGM Indore) General And Laproscopic Surgeon </p>
                                    {/* <h4>About him:</h4> */}
                                    {/* <div className="process-block_text" style={{ marginTop: "0px" }}>
                                                   नमस्कार,
                                                   मेरा नाम डॉ. मुलायम सिंह यादव है और मैं हड़ी एवं जोड़ रोग विशेषज्ञ हूं। मैंने एमबीबीएस एन.एस.सी.बी. मेडिकल कॉलेज, जबलपुर से किया है और पोस्ट ग्रेजुएशन हड्डी एवं जोड़ रोग विशेषज्ञ जी.आर.एम.सी. ग्वालियर से पूर्ण किया है। जिसमें मुझे गोल्ड मेडल प्राप्त हुआ है। वर्तमान में मैं एक अनुभवी ट्रॉमा एवं जॉइंट रिप्लेसमेंट सर्जन हूं। पिछले 8 वर्षों के अनुभव में मैंने देखा है कि जब मरीजों को घुटनों के खराब होने (घुटनों का ऑस्टियोआर्थराइटिस), कंधे के जाम होने या दर्द (फोजन शोल्डर), एड़ी में दर्द (प्लांटर फैसाइटिस) या फिर कोहनी की समस्या होती है, तो कई बार उन्हें सीधे सर्जरी की सलाह दे दी जाती है। लेकिन मैं आपसे यही कहना चाहता हूं कि सर्जरी से पहले एक बार PRP या स्टेम सेल थेरेपी अवश्य आजमाएँ।
                                               </div> */}

                                </div>

                            </div>
                        </div>

                    </div>

                </div>

            </section>

            <div className="sidebar-page-container left-sidebar" style={{ marginTop: "-230px" }}>
                <div className="auto-container">

                    <div className="row clearfix">
                        <div className="content-side col-lg-12 col-md-12 col-sm-12">
                            <div className="department-detail">
                                <div className="inner-box" >
                                    <h3 className='mt-lg-4'>क्या आप या आपका कोई परिचित इन लक्षणों से ग्रस्त हैं ?</h3>
                                    <div className="graph-outer">
                                        <div className="row clearfix">
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list">
                                                    <b> पेट के समस्त रोग</b>
                                                    <li className='mt-lg-4'> घाव का ठीक ना होना</li>
                                                    <li> पैरों की नशे सूजना</li>
                                                    <li> शरीर में कहीं गठान</li>
                                                    <li> ज्यादा गैस बनना </li>
                                                    <li> बवासीर (पाईल्स)</li>
                                                    <li> थायरॉइड एवं स्तन रोग</li>
                                                    <li> आँतों के रोग</li>
                                                    <li> पित्त की थैली के रोग</li>
                                                    <li> वेरिकोस वेन</li>
                                                    <li> लीवर रोग पेंक्रियाज</li>
                                                    


                                                </ul>
                                            </div>
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list">
                                                    <li> आंत एवं पेट का कैंसर </li>
                                                    <li> हाइड्रोसिल (अण्डकोष की वृद्धि)</li>
                                                    <li> शरीर के अन्य घाव एवं सूजन </li>
                                                    <li> किडनी रोग</li>
                                                    <li> भगंदर</li>
                                                    <li> फिशर</li>
                                                    <li> हॉर्निया</li>
                                                    <li> कब्ज</li>
                                                    <li> पथरी</li>
                                                    <li> मूत्र रोग</li>
                                                    <li> पैकेज में ऑपरेशन की सुविधा कम रेट में उपलब्ध हैं</li>


                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </>
    )
}

export default DrRohitDubey